// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__251BQ","row":"Node_row__2_evU","label":"Node_label__3X4EN","footer":"Node_footer__1nRQk"};